<time [attr.datetime]="datetime" [title]="hoverTime">{{ currentTime }}</time>
